/**
 * @desc
 * - displays an breadcrumb navigation
 */
;(function () {
  angular
    .module('contrast.breadcrumbs-nav')
    .directive('csBreadcrumbsNav', csBreadcrumbsNav)

  function csBreadcrumbsNav(
    $,
    $filter,
    $timeout,
    $window,
    csBreadcrumbsNavTypes
  ) {
    'ngInject'

    var initialRouteIndex = 0,
      routesEnabled = true

    return {
      restrict: 'E',
      transclude: true,
      scope: {
        routeParams: '=',
        routesEnabled: '=',
        navType: '@',
        clickFn: '&'
      },
      templateUrl: 'components/breadcrumbs_nav/cs-breadcrumbs-nav.html',
      controller: 'csBreadcrumbsNavCtrl',
      controllerAs: 'breadcrumbsNavCtrl',
      link: link
    }

    function link(scope, element, attrs, controller) {
      var transclude = element.find('ng-transclude'),
        navType = csBreadcrumbsNavTypes.large

      if (attrs.routesEnabled === 'false') {
        routesEnabled = false
      }

      if (scope.navType && csBreadcrumbsNavTypes[scope.navType]) {
        navType = csBreadcrumbsNavTypes[scope.navType]
      }

      element.addClass('cs-breadcrumbs-nav-' + navType)

      controller.activate(scope, navType)

      scope.$watch('routeParams', function (newValue, oldValue) {
        if (newValue != oldValue) {
          updateRoutes()
        }
      })

      function updateRoutes() {
        var routes = getRoutes(transclude.find('breadcrumb-route'), scope)
        clearBreadcrumbView()
        controller.setRoutes(routes, initialRouteIndex, scope.clickFn)
      }

      function clearBreadcrumbView() {
        element.find('#nav-breadcrumbs').empty()
      }

      updateRoutes()

      scope.$watch(
        function () {
          return transclude.find('breadcrumb-route').length
        },
        function (newValue, oldValue) {
          if (newValue != oldValue) {
            updateRoutes()
          }
        }
      )

      scope.$on('$locationChangeStart', function () {
        $timeout(function () {
          controller.setCircleAttrs()
        }, 100)
      })

      $window.addEventListener('resize', controller.setCircleAttrs)
    }

    function getRoutes(routeElements, scope) {
      var el = null,
        routes = [],
        len = routeElements.length,
        i = 0

      for (; i < len; i++) {
        el = $(routeElements[i])

        var route = {
          route: el.attr('route'),
          path: el.attr('params')
            ? scope.$eval(
                "'" +
                  el.attr('route') +
                  "' | routeSegmentUrl: " +
                  el.attr('params')
              )
            : el.attr('route')
            ? scope.$eval("'" + el.attr('route') + "' | routeSegmentUrl")
            : null,
          enabled: routesEnabled && el.attr('route-enabled') !== 'false'
        }

        if ($filter('routeSegmentStartsWith')(route.route)) {
          initialRouteIndex = i
        }

        routes.push(route)
      }

      return routes
    }
  }
})()
